import { render } from "./IconLogo.vue?vue&type=template&id=4ae893a7"
import script from "./IconLogo.vue?vue&type=script&lang=js"
export * from "./IconLogo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__